<template>
    <div class="banner-image-area position-relative section-space--pb_90">
        <div class="container_fl">
            <div class="row align-items-center">
                <div class="col-lg-2 order-1 order-lg-1 wow move-up"></div>
                <div class="col-lg-8 order-2 order-lg-2 wow move-up mission-statement" v-html="$t('home.mission_statement')"></div>
                <div class="col-lg-2 order-3 order-lg-3 wow move-up"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default{
        name: 'MissionStatement',
    };
</script>
